import { DisposableStore } from "../../../base/common/lifecycle.js";
import type { IKeybindingService } from "../../keybinding/common/keybindingService.js";

export function registerQuickInputKeybindings(keybindings: IKeybindingService): DisposableStore {
    const registrations = new DisposableStore();
    registrations.add(keybindings.registerKeybinding({
        id: "keybinding.quickOpen",
        key: "Ctrl+P",
        commandId: "quickinput.show",
        preventDefault: true,
        allowOnCanvas: true,
    }));
    registrations.add(keybindings.registerKeybinding({
        id: "keybinding.quickOpen-alternate",
        key: "Ctrl+E",
        commandId: "quickinput.show",
        preventDefault: true,
    }));
    registrations.add(keybindings.registerKeybinding({
        id: "keybinding.quickOpen-command",
        key: "Ctrl+Shift+P",
        commandId: "quickinput.show",
        preventDefault: true,
        args: { prefix: ">" },
    }));
    return registrations;
}
